/* eslint-disable */
import { uniqBy } from 'lodash';
import { useHistory } from 'react-router';
import { fallbackNavigation } from '~/controllers/fallbackNavigation';
import { ApplicationStep } from '~/types/ApplicationStep';
import { ApplicationNavStepProps } from '~/layouts/ApplicationNavStep';
import { getStagePayload } from '~/utils/getStagePayload';
import { useGetApplication, useSelectStep } from './wizard';
import paths from '~/pages/paths';
import { useEffect } from 'react';

export const useGetApplicationNavSteps = () => {
  const applicationQuery: any = useGetApplication();
  const stagePayload = getStagePayload.wizard(applicationQuery?.data);
  const navSteps: any = fallbackNavigation?.navigation;

  return {
    stagePayload,
    isLoading: applicationQuery.isLoading,
    navStepsQuery: navSteps,
    data: applicationQuery?.data,
    refetch: applicationQuery?.refetch,
  };
};
export const useGetWizardNavSteps = (stageKey: string, rootPath: string, rootStep: string) => {
  const applicationQuery = useGetApplication();
  const stagePayload = getStagePayload.wizard(applicationQuery.data);
  const stage = applicationQuery.data?.stage;
  const applicationSteps = stagePayload?.steps.find((item) => item.key === rootStep)?.steps;

  const navSteps: Omit<ApplicationNavStepProps, 'index'>[] =
    uniqBy(
      applicationSteps?.filter((item: any) => item.state !== 'HIDDEN'),
      'pathKey'
    )?.map((item: any) => {
      const { stepName, key, state, pathKey, validationState } = item;
      return {
        name:
          stage !== 'ksaReview' && stage !== 'ksaContract' && pathKey === 'screeningResult'
            ? 'Status & Screening Results'
            : stepName,
        stageKey,
        stepKey: key,
        route: `${rootPath}/${pathKey}`,
        done: validationState === 'OK',
        validationError: validationState === 'VALIDATION_ERROR',
        disabled: stage === 'ksaReview' && pathKey === 'contractReview',
      };
    }) || [];

  return { isLoading: applicationQuery.isLoading, data: navSteps };
};

export const useNavigateToStepByKey = (stageKey: string, rootPath: string, rootStep: string) => {
  const selectStepMutation = useSelectStep();
  const history = useHistory();
  const navStepsQuery = useGetWizardNavSteps(stageKey, rootPath, rootStep);

  const navigate = async (stepKey: ApplicationStep['key']) => {
    if (navStepsQuery.isLoading) return;
    if (selectStepMutation.isLoading) return;
    const step = navStepsQuery.data.find((item) => item.stepKey === stepKey);
    if (!step) return;
    try {
      await selectStepMutation.mutateAsync({ stageKey, stepKey: step.stepKey });
      history.push(step.route);
    } catch (error) {
      //
    }
  };

  return { isLoading: navStepsQuery.isLoading, navigate };
};
